import { DefaultState } from 'store/reducers/types';

export const READ_DEDICATED_WORKER_REPORT_DATA_REQUEST = "READ_DEDICATED_WORKER_REPORT_DATA_REQUEST";
export const READ_DEDICATED_WORKER_REPORT_DATA_SUCCESS = "READ_DEDICATED_WORKER_REPORT_DATA_SUCCESS";
export const READ_DEDICATED_WORKER_REPORT_DATA_FAILURE = "READ_DEDICATED_WORKER_REPORT_DATA_FAILURE";

export interface DedicatedWorkerReportRow {
  id: number;
  associatesCount: number;
  future: number;
  inThreeWeeks: number;
  inTwoWeeks: number;
  nextWeek: number;
  role: string;
  thisWeek: number;
  workedLastDays: number;
};

export interface DedicatedWorkerReportData {
  rows: DedicatedWorkerReportRow[] | [];
  totalCount: number;
};

export type DedicatedWorkerReportState = DefaultState & {
  contents?: DedicatedWorkerReportData;
};

interface ReadDedicatedWorkerReportDataRequest {
  type: typeof READ_DEDICATED_WORKER_REPORT_DATA_REQUEST;
};

interface ReadDedicatedWorkerReportDataSuccess {
  type: typeof READ_DEDICATED_WORKER_REPORT_DATA_SUCCESS,
  contents: DedicatedWorkerReportData
}

interface ReadDedicatedWorkerReportDataFailure {
  type: typeof READ_DEDICATED_WORKER_REPORT_DATA_FAILURE;
}

export type DedicatedWorkerReportActionTypes = ReadDedicatedWorkerReportDataRequest | ReadDedicatedWorkerReportDataSuccess | ReadDedicatedWorkerReportDataFailure;
  